import { Grid, Paper, Typography } from '@mui/material'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import { Doughnut } from 'react-chartjs-2'
import { colors } from '~constants/colorsPallete'

ChartJS.register(ArcElement, Tooltip, Legend)

const MONTH_NAMES = [
  'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
  'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro',
]

function formatMonthLabel(date: string): string {
  if (!date) return ''
  const [year, month] = date.split('/')
  const monthIndex = Number(month) - 1
  if (monthIndex < 0 || monthIndex > 11) return ''
  return `${MONTH_NAMES[monthIndex]} ${year}`
}

export default function SatisfactionCard({ data, date }: { data: any; date?: string }) {
  const detratores = data[0]
  const neutro = data[1]
  const promotores = data[2]

  const total = detratores + neutro + promotores
  const noResponses = total === 0

  const chartData = noResponses ? [0, 0, 0] : [detratores, neutro, promotores]

  const datas = {
    labels: ['Detratores', 'Neutros', 'Promotores'],
    datasets: [
      {
        label: 'Índice de Satisfação dos Médicos',
        data: chartData,
        backgroundColor: ['#E96338', '#E4BE34', '#009D81'],
      },
    ],
  }

  const percentualPromotores = noResponses ? 0 : (promotores / total) * 100
  const percentualDetratores = noResponses ? 0 : (detratores / total) * 100

  const score = percentualPromotores - percentualDetratores

  const scoreValue = Number.isFinite(score) ? score : 0

  const scoreLabor = (score) => {
    if (score > 74) {
      return (
        <Typography variant="subtitle1" color={colors['green.default']} fontWeight={500} mt={1} mb={2}>
          Excelente
        </Typography>
      )
    }
    if (score > 49 && score < 75) {
      return (
        <Typography variant="subtitle1" color={colors.blue} fontWeight={500} mt={1} mb={2}>
          Muito Bom
        </Typography>
      )
    }
    if (score > 0 && score < 50) {
      return (
        <Typography variant="subtitle1" color={colors.warn} fontWeight={500} mt={1} mb={2}>
          Razóavel
        </Typography>
      )
    } else
      return (
        <Typography variant="subtitle1" color={colors.error} fontWeight={500} mt={1} mb={2}>
          Ruim
        </Typography>
      )
  }

  return (
    <Grid item xs={12} md={6}>
      <Paper variant="outlined" square={false}>
        <Grid container p={2}>
          <Grid item mb={3} lg={12} sm={12} xs={12} md={12}>
            <Typography variant="subtitle1" color={colors['gray.500']} fontWeight={700}>
              Índice de Satisfação dos Médicos
            </Typography>
            <Typography variant="subtitle2" color={colors['gray.500']} fontWeight={300}>
              NPS {formatMonthLabel(date)}
            </Typography>
          </Grid>
          <Grid
            item
            lg={12}
            sm={12}
            xs={12}
            md={12}
            style={{
              height: 320,
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
              alignItems: 'center',
              alignContent: 'center',
            }}
          >
            <Doughnut
              data={datas}
              options={{
                responsive: true,
                plugins: {
                  legend: {
                    position: 'bottom' as const,
                    display: true,
                  },
                },
              }}
            />
            <Typography
              variant="h6"
              color={colors['gray.500']}
              fontWeight={500}
              style={{ position: 'absolute', marginTop: '-100px' }}
            >
             {scoreValue.toFixed(0)}
            </Typography>
            {scoreLabor(scoreValue)}
            {noResponses && (
              <Typography variant="caption" color={colors['gray.500']} mt={1}>
                Sem respostas no período
              </Typography>
            )}
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  )
}
